import { useCallback, useEffect, useState } from 'react';
import { discoveryApiRef, fetchApiRef, useApi } from '@backstage/core-plugin-api';

/** Llamada al backend `releases` (GET sin body, POST con body); lanza el error que devuelve el backend. */
export const useReleasesCall = () => {
  const discovery = useApi(discoveryApiRef);
  const { fetch } = useApi(fetchApiRef);
  return useCallback(
    async (path: string, body?: unknown) => {
      const res = await fetch(`${await discovery.getBaseUrl('releases')}${path}`, {
        method: body ? 'POST' : 'GET',
        headers: { 'Content-Type': 'application/json' },
        body: body ? JSON.stringify(body) : undefined,
      });
      const json = await res.json().catch(() => ({}));
      if (!res.ok) throw new Error(json.error?.message ?? json.error ?? `HTTP ${res.status}`);
      return json;
    },
    [discovery, fetch],
  );
};

/** true solo para devops y arquitectos; undefined mientras se consulta. */
export const useReleasesAccess = () => {
  const call = useReleasesCall();
  const [allowed, setAllowed] = useState<boolean>();
  useEffect(() => {
    call('/access').then(r => setAllowed(Boolean(r.allowed)), () => setAllowed(false));
  }, [call]);
  return allowed;
};
